exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-467734ce]{background:#000;opacity:.7}.overlay-enter[data-v-467734ce],.overlay-leave-to[data-v-467734ce]{opacity:0}.overlay-enter-active[data-v-467734ce],.overlay-leave-active[data-v-467734ce]{transition:all .3s}", ""]);

// exports
